import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TiptapEditor from "../../../component/TiptapEditor";
import { boardError, freeBoardApi } from "./api";
import "../../../assets/css/container/board/freeboard/FreeBoard.css";
import "../../../assets/css/component/board/BoardActions.css";

export default function FreePostEditor() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(!!id);
    const [ready, setReady] = useState(!id);
    const [saving, setSaving] = useState(false);
    const pending = useRef(false);
    const [error, setError] = useState("");
    const cancelUrl = id ? `/freeboard/${id}` : "/freeboard";
    useEffect(() => {
        const controller = new AbortController();
        setTitle(""); setContent(""); setError(""); setReady(!id); setLoading(!!id);
        if (id) freeBoardApi.read(id, true, controller.signal).then(({ data }) => {
            if (!controller.signal.aborted) { setTitle(data.title); setContent(data.content); setReady(true); }
        }).catch(err => { if (!controller.signal.aborted) setError(boardError(err)); })
            .finally(() => { if (!controller.signal.aborted) setLoading(false); });
        return () => controller.abort();
    }, [id]);
    const save = async () => {
        if (pending.current || !ready) return;
        const body = new DOMParser().parseFromString(content, "text/html");
        if (!title.trim() || (!body.body.textContent?.trim() && !body.querySelector("img[src]"))) { setError("제목과 본문을 입력해주세요."); return; }
        if (title.trim().length > 200 || content.length > 100000) { setError("제목은 200자, 본문 HTML은 100,000자 이내로 입력해주세요."); return; }
        pending.current = true; setSaving(true); setError("");
        try { const { data } = await freeBoardApi.save({ title: title.trim(), content }, id); navigate(`/freeboard/${data.id}`, { replace: true }); }
        catch (err) { setError(boardError(err)); }
        finally { pending.current = false; setSaving(false); }
    };
    return <section className="FreeBoard FreePostEditor">
        <h1>{id ? "자유게시판 글 수정" : "자유게시판 글쓰기"}</h1>
        {error && <p role="alert">{error}</p>}
        {loading ? <p role="status">불러오는 중...</p> : ready && <fieldset disabled={saving}>
            <label htmlFor="free-post-title">제목</label>
            <input id="free-post-title" value={title} maxLength={200} placeholder="제목을 입력해주세요" onChange={e => setTitle(e.target.value)}/>
            <label>본문</label>
            <TiptapEditor content={content} onChange={setContent}/>
        </fieldset>}
        <div className="BoardEditorActions">
            {ready && !loading && <button type="button" disabled={saving} onClick={save}>{saving ? "저장 중..." : id ? "수정 완료" : "등록"}</button>}
            <button type="button" disabled={saving} onClick={() => navigate(cancelUrl)}>취소</button>
        </div>
    </section>;
}
